import { render, staticRenderFns } from "./SubHireButton.vue?vue&type=template&id=28f3fddb"
import script from "./SubHireButton.vue?vue&type=script&lang=js"
export * from "./SubHireButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports